import { Image, ImageProps } from '@chakra-ui/react';

export interface Props extends ImageProps {
  code: string;
}

const FlagIcon = ({ code, ...rest }: Props) => (
  <Image src={`/images/flags/64/${code}.png`} {...rest} />
);

export default FlagIcon;
